import { Box, Button, Icon, Typography } from "@saviynt/design-system";
import { FormattedMessage } from "react-intl";
import { useExecuteQuery } from "../../../hooks/usePolicy";
import InventoryList from "../InventoryPageList/InventoryList";
import { usePoliciesForm } from "../PoliciesFormContext";
import CodeEditor from "./CodeEditor";
import { useState } from "react";
import { QueryPayload } from "@repo/api/clients/policies.api";
import { PermissionProvider } from "../../../context/permissionContext";

export default function IQLPlayground() {
  const { evaluationCriteria } = usePoliciesForm();
  const [payload, setPayload] = useState<QueryPayload>();

  const queryItems = useExecuteQuery(payload);

  const handleRunQuery = () => {
    const payload = {
      query: evaluationCriteria,
      limit: 20,
      offset: 0,
    };
    setPayload(payload);
  };

  return (
    <>
      <div className="mb-1 flex items-center justify-between">
        <Typography kind="label" desktop="h3-d" mobile="h3-d">
          <FormattedMessage
            defaultMessage="Evaluation Criteria"
            id="XIEjI5"
            description="Label for evaluation criteria"
          />
        </Typography>
        <Button
          kind="outlined"
          leftIcon={
            <Icon kind="PlayFilled" color="--color-foreground-success-medium" />
          }
          size="small"
          onClick={handleRunQuery}
        >
          <FormattedMessage
            defaultMessage="Run Query"
            id="y92iZw"
            description="Button to run policy query"
          />
        </Button>
      </div>

      <CodeEditor />

      {/* Results */}
      {payload && (
        <Box className="pt-4">
          <div className="px-3 py-2">
            <Typography kind="label" desktop="h3-d" mobile="h3-d">
              <FormattedMessage
                defaultMessage="Result"
                id="veRDh/"
                description="Label for Results"
              />
            </Typography>
          </div>

          <div className="flex flex-col">
            <PermissionProvider>
              <InventoryList queryItems={queryItems} />
            </PermissionProvider>
          </div>
        </Box>
      )}
    </>
  );
}
